// React
import React from 'react';

// Packages
import t from 'prop-types';

// Utilities
import { useInitiativeDataStore } from 'utilities/store';
import { useLabels, useContext, useFormat } from 'utilities/hooks';
import { useReportContent } from '../contentProviderHooks';

// Components
import BaseCard from './_common/baseCard.js';

// Icons
import { FiTrendingUp } from 'react-icons/fi';

const FunderSummary = ({ promptKey, forceOpen }) => {
    // ///////////////////
    // STORES
    // ///////////////////

    const { utilities } = useInitiativeDataStore();

    // ///////////////////
    // HOOKS
    // ///////////////////

    const { REPORT_ID } = useContext();
    const { label, getValueLabel } = useLabels();
    const { date } = useFormat();
    const { HiddenRender, getSanitizedHtml } = useReportContent();

    // ///////////////////
    // REFS
    // ///////////////////

    // ///////////////////
    // DATA
    // ///////////////////

    const initiative = utilities.initiative.get();
    const report = utilities.reports.get(REPORT_ID);

    // ///////////////////
    // RENDER
    // ///////////////////

    return (
        <>
            {HiddenRender}
            <BaseCard
                {...{
                    forceOpen,
                    title: label('AI_PromptTitle_Funder_Summary'),
                    description: label('AI_PromptDescription_Funder_Summary'),
                    relation: {
                        key: 'Initiative_Report__c',
                        id: REPORT_ID,
                        name: initiative?.Name,
                        type: `${getValueLabel(
                            'Initiative_Report__c.Report_Type__c',
                            report?.Report_Type__c
                        )} ${label('CardTypeReport')} (${date(
                            report?.Due_Date__c
                        )})`,
                    },
                    icon: FiTrendingUp,
                    promptKey,
                    systemPrompts: [
                        'You will help the user to summarize the report based on the prompts provided.',
                        'If the report content is not available or detailed enough, provide a summery where you can, and then ask the user for more details.',
                        'Do not include any general heading or other headings than the sections asked for.',
                        'Do not mention object keys like "Status__c" or "Report_Type__c".',
                        'The answer you provide should be in unescaped html tags for immediate parsing.',
                        'No wrapping <div>. Use <p> tags for paragraphs and <strong> for bold text and headings.',
                    ],
                    promptDataGetter: getSanitizedHtml,
                }}
            />
        </>
    );
};

FunderSummary.propTypes = {
    promptKey: t.string.isRequired,
};

FunderSummary.defaultProps = {
    promptKey: '',
};

export default FunderSummary;
